import styled from "styled-components";

export const ButtonsDiv = styled.div`
  display: flex;
  justify-content: center;
  gap: 3em;
`;

export const ContentContainer = styled.div`
  margin-top: 0.75em;
  margin-left: 5em;
  margin-right: 5em;
  text-align: center;
  justify-content: space-around;
  padding: 1em;

  > p {
    padding-left: 2.5em;
    padding-right: 2.5em;
  }

  > h2 {
    margin-bottom: 1em;
  }
`;
